//import React from 'react'
//import Nav from './navbar-hp';
//import { Outlet, Link, NavLink } from "react-router-dom";
import { useState, useEffect } from "react"
import "98.css";

export default function Mothership({onClose}) {

    const [loaded, setLoaded] = useState(false);

    // var message = [
    //     'TEST',                                  //0
    //     'WELCOME TO THE MOTHERSHIP',             //1
    //     'Initialising v1.0',                     //2
    //     'Connecting systems',                    //3
    //     '100',                                   //4
    //     'Status FAILED',                         //5
    //     'Connection Successful'                  //6
    // ];

    useEffect(() => {
        var counter = 0;
        var elips = ['', '.', '..', '...'];
        let intervalId = setInterval(() => {
            document.querySelector('.message-container span').innerText = elips[counter];
            if (counter === 3) {
                counter = 0;
            } else {
                counter += 1;
            }
            if (document.querySelector('.progress-indicator-bar').getAttribute('style') === 'width: 0%;') {
                document.querySelector('.progress-indicator-bar').style.width = '5%';
            } else {
                document.querySelector('.progress-indicator-bar').style.width = '0%';
            }
        }, 500);

        // cleanup the interval when component unmounts
        return () => clearInterval(intervalId);

    }, []);

    function minimise(e) {
        var selector = e.target;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');
        //dataName = '[data-name="' + dataName + '"]';

        tray.querySelector('[data-name="' + dataName + '"]').removeAttribute('aria-selected');
        selector.closest('.window') && selector.closest('.window').classList.add('hidden');
    }

    function reOpen(selector) {
        
        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });

        var selector = selector.target;
        //console.log(selector);
        var dataName = selector.getAttribute('data-name');

        document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));

        if (document.querySelector('.window[data-name="' + dataName + '"]')) {
            selector.ariaSelected = 'true';
            document.querySelector('.window[data-name="' + dataName + '"]').classList.remove('hidden');
        }
    }
    
    // function hideContactForm(e) {
    //     var el = e.target;
    //     //console.log(el);
    //     var dataName = el.getAttribute('data-name');
    //     checkTray(el, true);
    //     document.querySelector('.window[data-name="' + dataName + '"]').classList.add('hidden');
    // }

    function checkTray(selector, close=false) {
        var selector = selector;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');

        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });
        //dataName = '[data-name="' + dataName + '"]';
    
        //console.log(dataName)
        if (!tray.querySelector('[data-name="' + dataName + '"]')) {
            //console.log('not in tray, add it!')

            document.querySelectorAll('.tray button').forEach(item => {
                item.ariaSelected = 'false';
            });
    
            var el = document.createElement('button');
            el.role = "tab";
            el.innerText = dataName;
            //el.insertAdjacentHTML('afterbegin', '<a>' + dataName + '</a>');
            el.ariaSelected = "true";
            el.setAttribute('data-name', dataName);
            el.onclick = reOpen;
            document.querySelector('.tray menu').insertAdjacentElement('beforeend', el);

            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else if (!close) {
            
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else {
            //console.log('already in tray');
            tray.querySelector('[data-name="' + dataName + '"]').remove();
        }
    }

    // function generateMessage1(destination) {
    //     if (document.querySelector(destination).innerHTML === '') {

            

    //         document.querySelectorAll('.window[data-name="The Mothership"] .message-container').forEach(container => {
    //             var index = Array.from(document.querySelectorAll('.window[data-name="The Mothership"] .message-container')).indexOf(container);
    //             //typeWriteRun(message[index], '.window[data-name="The Mothership"] .message-header.inner');
    //             typeWriteRun(message[index], document.querySelectorAll('.window[data-name="The Mothership"] .message-container .message-header.inner')[index]);
    //         })

            

    //         //typeWriteRun(message1, '.window[data-name="The Mothership"] .message-header.inner');
    //         {/*setTimeout(function() {
    //             typeWriteRun(messageContent, '.window[data-name="The Mothership"] .message-content');
    //         }, 1000);*/}

    //     }
    // }

    return !loaded ? (

        <div className="window" data-name="The Mothership">

            <div className="title-bar">
                <div className="title-bar-text">The Mothership</div>
                <div className="title-bar-controls">
                    <button className="form-minimise" aria-label="Minimize" onClick={minimise} data-name="The Mothership"></button>
                    <button className="form-close" aria-label="Close" onClick={onClose} data-name="The Mothership"></button>
                </div>
            </div>

            <div className="window-body">
                
                <p className="message-container">Connecting<span></span></p>
                <div className="progress-indicator segmented">
                    <span className="progress-indicator-bar" style={{width: '0%'}}/>
                </div>
                
                {/* <br></br>
                <p className="message-container left-text-align">
                    <span className="message-header zero-vis">
                    <span className="message-header inner"></span>...100%</span>
                </p> */}
                
                {/* <br></br>
                <br></br>
                <div className="connecting-icons-container" style={{visibility: "hidden"}}>
                    <div className="connecting-icons satellite"></div>
                    <div className="progress-indicator">
                        <span className="progress-indicator-bar" style={{width: '0%'}}/>
                    </div>
                    <div className="connecting-icons computer"></div>
                </div> */}

            </div>

        </div>

         
    ) : (

        <>

        <div className="window" data-name="The Mothership">

            <div className="title-bar">
                <div className="title-bar-text">The Mothership</div>
                <div className="title-bar-controls">
                    <button className="form-minimise" aria-label="Minimize" onClick={minimise} data-name="The Mothership"></button>
                    <button className="form-close" aria-label="Close" onClick={onClose} data-name="The Mothership"></button>
                </div>
            </div>

            <div className="window-body">
                
                <p className="message-container">
                    <span className="message-header">
                    <span className="message-header inner Lenny"></span>(° ʖ°)</span>
                </p>

            </div>

        </div>

        </>
    )
}